import React, { useState, useEffect, useCallback } from 'react';
import {
  Card, CardContent, Table, TableHead, TableRow, TableCell, TableBody,
  Button, TablePagination, Box,
} from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import { useParams } from 'react-router-dom';
import Layout from '../../components/Layout/Layout';
import PageHeader from '../../components/Common/PageHeader';
import { getBookRequestBooksApi, exportBookRequestBooksApi } from '../../api/books';

function downloadBlob(blob, filename) {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  window.URL.revokeObjectURL(url);
}

export default function BookRequestBooks() {
  const { id } = useParams();
  const [books, setBooks] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const fetchBooks = useCallback(async () => {
    const res = await getBookRequestBooksApi(id, { page: page + 1, page_size: rowsPerPage });
    setBooks(res.data.results || res.data);
    setTotal(res.data.count || res.data.length);
  }, [id, page, rowsPerPage]);

  useEffect(() => { fetchBooks(); }, [fetchBooks]);

  const handleExport = async (fileFormat) => {
    const res = await exportBookRequestBooksApi(id, { export_format: fileFormat });
    downloadBlob(res.data, `book_request_${id}_books.${fileFormat}`);
  };

  return (
    <Layout title="Book Requests">
      <PageHeader
        title="Requested Books"
        breadcrumbs={[{ label: 'Admin', path: '/admin/dashboard' }, { label: 'Book Requests', path: '/admin/book-requests' }, { label: 'Books' }]}
        action={
          <Box sx={{ display: 'flex', gap: 1 }}>
            <Button variant="outlined" startIcon={<DownloadIcon />} onClick={() => handleExport('csv')}>Export CSV</Button>
            <Button variant="outlined" startIcon={<DownloadIcon />} onClick={() => handleExport('xlsx')}>Export Excel</Button>
          </Box>
        }
      />
      <Card>
        <CardContent>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>ISBN</TableCell>
                <TableCell>Title</TableCell>
                <TableCell>Author</TableCell>
                <TableCell>Publisher</TableCell>
                <TableCell>Language</TableCell>
                <TableCell>Price</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {books.map((b) => (
                <TableRow key={b.id} hover>
                  <TableCell>{b.isbn}</TableCell>
                  <TableCell sx={{ maxWidth: 200, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{b.title}</TableCell>
                  <TableCell>{b.author_name}</TableCell>
                  <TableCell>{b.publisher_company || b.publisher_name}</TableCell>
                  <TableCell>{b.language}</TableCell>
                  <TableCell>₹{b.price}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
          <TablePagination component="div" count={total} page={page} rowsPerPage={rowsPerPage}
            onPageChange={(_, p) => setPage(p)}
            onRowsPerPageChange={(e) => { setRowsPerPage(+e.target.value); setPage(0); }}
            rowsPerPageOptions={[10, 25, 50, 100]} />
        </CardContent>
      </Card>
    </Layout>
  );
}
